import { applyMiddleware, createStore } from 'redux'
import storage from 'redux-persist/es/storage'
import { composeWithDevTools } from 'redux-devtools-extension'
import { INITIAL_DASHBOARD_ENTITY_STATE } from './entity/entityConstants'
import { persistReducer, persistStore } from 'redux-persist'
import createTransform from 'redux-persist/es/createTransform'
import thunk from 'redux-thunk'

import reducer from './reducer'

// Omit compare fields from localStorage persistence.
// - Tab close / refresh / new tab: compare starts empty (not rehydrated)
// - In-app navigation: compare stays in Redux memory for the tab lifetime
// redux-persist runs transforms per top-level key, so whitelist 'entities'.
const compareBlacklistTransform = createTransform(
    (state, key) => {
        if (key !== 'entities' || !state) return state
        const { compareEntities, compareFilters, compareSearch, compareCandidates, activePortfolio, ...rest } = state
        return rest
    },
    (state, key) => {
        if (key !== 'entities' || !state) return state
        const { compareEntities, compareFilters, compareSearch, compareCandidates, activePortfolio, ...rest } = state
        return rest
    },
    { whitelist: ['entities'] }
)

// we could choose to just only persist auth...
// UX is way better with everything persisted
const persistConfig = {
    key: 'root',
    storage,
    transforms: [compareBlacklistTransform],
}

const INITIAL_STATE = { entities: INITIAL_DASHBOARD_ENTITY_STATE }

const persistedReducer = persistReducer(persistConfig, reducer)
const store = createStore(
    persistedReducer,
    INITIAL_STATE,
    composeWithDevTools(applyMiddleware(thunk))
)

const persistor = persistStore(store)

export { persistor, store }
